
import { RevLink } from '@ds/components/Link'

import translations from '../../pages/product.translations'

export default {
  components: {
    RevLink,
  },
  computed: {
    translations: () => translations,
    showVatInfoBlock() {
      // In some countries (hello Japan!), we want to display the VAT included info below the price
      // (using the `vatIncluded` boolean in config/app.js), but we don't want to display the * with more details
      // below the seller block. So we check if the translation is set to do so.
      return this.$t(translations.productVatIncludedInfo)
    },
  },
}
